import React from 'react'
import { conformDeliveryUrl } from '../../../../utils/mediaDeliveryUrls'

class StaticSlideChoiceImage extends React.Component {
  constructor(props) {
    super(props)
    this.onLoad = this.onLoad.bind(this)
  }

  onLoad() {
    if (this.props.choiceMediaPromiseResolve) {
      console.log(`choice ${this.props.choiceLetter} image onLoad`)
      this.props.choiceMediaPromiseResolve()
    }
  }

  render() {
    const { image } = this.props

    return (
      <React.Fragment>
        <img
          onLoad={this.onLoad}
          src={conformDeliveryUrl(image.deliveryUrl)}
          alt="Choice"
          className={`slide-choice-media--image-image ${image.imageFill ? ' slide-choice-media--image-image--fill' : 'slide-choice-media--image-image--fit'}`}
        />
      </React.Fragment>
    )
  }
}

export default StaticSlideChoiceImage
